import { LANGUAGE_LEVEL_LABELS, SENIORITY_LABELS, type PublicPro } from '../catalog.ts';

const chip = (text: string, key = text) => <span key={key} className="badge badge-neutral">{text}</span>;

function Block({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <div style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--text-tertiary)', textTransform: 'uppercase', marginBottom: 6 }}>{title}</div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>{children}</div>
    </div>
  );
}

// Version courte pour les listes : postes et séniorité, c'est ce qui compte au premier coup d'œil.
export function ProLine({ pro }: { pro?: PublicPro }) {
  if (!pro || pro.roles.length === 0) return null;
  return (
    <div style={{ fontSize: 12.5, color: 'var(--text-secondary)' }}>
      {pro.roles.slice(0, 2).map((r) => `${r.label.split(' / ')[0]} · ${SENIORITY_LABELS[r.level] ?? r.level}${r.years ? ` · ${r.years} an${r.years > 1 ? 's' : ''}` : ''}`).join(' — ')}
    </div>
  );
}

export function ProSummary({ pro }: { pro?: PublicPro }) {
  if (!pro) return null;
  const empty = pro.roles.length + pro.skills.length + pro.pos.length + pro.languages.length + pro.certifications.length + pro.equipment.length === 0;
  if (empty) return <div className="card" style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Cet extra n'a pas encore détaillé son profil professionnel.</div>;
  return (
    <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {pro.roles.length > 0 && (
        <Block title="Postes">
          {pro.roles.map((r) => chip(`${r.label.split(' / ')[0]} · ${SENIORITY_LABELS[r.level] ?? r.level}${r.years ? ` · ${r.years} ans` : ''}${r.maxCovers ? ` · jusqu'à ${r.maxCovers} couverts` : ''}`, r.label))}
        </Block>
      )}
      {pro.pos.length + pro.reservationTools.length > 0 && <Block title="Logiciels">{[...pro.pos, ...pro.reservationTools].map((t) => chip(t))}</Block>}
      {pro.languages.length > 0 && <Block title="Langues">{pro.languages.map((l) => chip(`${l.label} · ${LANGUAGE_LEVEL_LABELS[l.level] ?? l.level}`, l.label))}</Block>}
      {pro.certifications.length > 0 && <Block title="Certifications">{pro.certifications.map((c) => chip(c))}</Block>}
      {pro.equipment.length > 0 && <Block title="Équipement personnel">{pro.equipment.map((c) => chip(c))}</Block>}
      {pro.skills.length > 0 && <Block title="Compétences">{pro.skills.map((c) => chip(c))}</Block>}
      {pro.shifts.length > 0 && <Block title="Disponible pour">{pro.shifts.map((c) => chip(c))}</Block>}
      <Block title="Déplacements">
        {chip(`Rayon ${pro.mobility.maxTravelKm} km`)}
        {pro.mobility.drivingLicense && chip('Permis B')}
        {pro.mobility.ownVehicle && chip('Véhicule personnel')}
        {pro.transports.map((t) => chip(t))}
      </Block>
    </div>
  );
}
